<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-menu-button auto-hide="false" data-test="sidemenuButton"></ion-menu-button>
        </ion-buttons>
        <ion-title data-test="title" #title>Account</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <!-- <ion-list-header color="secondary">
        Information about your ShuttleNomix account.
    </ion-list-header> -->

    <ion-list class="ion-text-wrap">
        <ion-item-divider color="tertiary">
            Account Details
        </ion-item-divider>

        <ion-item [disabled]=vb.disabled detail="true" id="profile" href="javascript:;" data-test="accountProfile"
            (click)="onAccountProfileClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Account Profile</span><br />
                <span class="line2">Account detail information.</span>
            </ion-label>
        </ion-item>

        <ion-item-divider color="tertiary">
            Purchases
        </ion-item-divider>

        <ion-item [disabled]=vb.disabled detail="true" id="orders" href="javascript:;" data-test="orders"
            (click)="onOrdersClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Orders</span><br />
                <span class="line2">View orders history.</span>
            </ion-label>
        </ion-item>

        <!-- ptb
        <ion-item-divider color="tertiary">
            Miscellaneous
        </ion-item-divider>

        <ion-item [disabled]=vb.disabled detail="true" href="javascript:;" 
                data-test="deleteAccount" (click)="onDeleteAccountClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Delete Account</span><br />
                <span class="line2">Delete data associated with this login and prevent future logins.</span>
            </ion-label>
        </ion-item> -->



        <!-- 
        <ion-item [disabled]=vb.disabled detail="true" id="credits" routerLink="/credits" router-direction="forward">
            <ion-label class="ion-text-wrap">
                <span class="line1">Credits</span><br />
                <span class="line2">View credit usage.</span>
            </ion-label>
        </ion-item> -->

        <!-- <br />
        <ion-item-divider color="tertiary">
            <ion-label class="ion-text-wrap">
                To manage your account, please go to the ShuttleNomix website and login.
                From there you will be able to view prior trans-actions, make payments, upgrade or downgrade
                your package and even cancel.
                <br /><br />
                If you have any questions about your account, please contact us. Our contact
                information is shown on the 'Contact Us' page. Click on 'Help' and then click on 'Contact Us'.
            </ion-label>
        </ion-item-divider> -->
    </ion-list>
</ion-content>